import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/login-banner.png'
import _imports_1 from '../../assets/svg/logo-color.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "side-pic hidden-xs",
  src: _imports_0,
  alt: "login banner"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "login-logo",
  src: _imports_1,
  alt: "smart logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-med welcome" }, " Welcome to SMART+! ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "continue" }, " Log in to continue ", -1)
const _hoisted_5 = { class: "input-border email-border" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "input-label email font-med" }, " EMAIL ADDRESS ", -1)
const _hoisted_7 = { class: "input-border password-border" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "input-label password font-med" }, " PASSWORD ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, " Remember Me ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Forgot Password? ")
const _hoisted_11 = {
  class: "login-button font-med cursor-pointer",
  type: "submit"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "sign-up" }, [
  /*#__PURE__*/_createTextVNode(" Don't have an account? "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "font-med",
    href: "/sign-up"
  }, "Sign Up")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Col = _resolveComponent("Col")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Row = _resolveComponent("Row")!
  const _component_LoadingOutlined = _resolveComponent("LoadingOutlined")!
  const _component_Spin = _resolveComponent("Spin")!

  return (_openBlock(), _createBlock(_component_Row, {
    class: "login font-reg",
    type: "flex"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Col, { class: "hidden-xs" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_Col, {
        class: "form",
        flex: "auto"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.sign(_ctx.email, _ctx.password, _ctx.rememberMe)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Input, {
                class: "info-input",
                placeholder: "Enter Email Address",
                value: _ctx.email,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                type: "email",
                required: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Password, {
                required: "",
                class: "info-input",
                placeholder: "Enter Password",
                value: _ctx.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_Row, null, {
              default: _withCtx(() => [
                _createVNode(_component_Col, {
                  class: "remember",
                  xs: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Checkbox, { onChange: _ctx.onCheckChange }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Col, {
                  class: "forgot",
                  xs: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      id: "forgot-password",
                      to: _ctx.resetPasswordLocation
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_11, [
                _createVNode(_component_Spin, { spinning: _ctx.loading }, {
                  indicator: _withCtx(() => [
                    _createVNode(_component_LoadingOutlined, { style: { color: '#FFFFFF'} })
                  ]),
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["spinning"])
              ])
            ])
          ], 32),
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}